import {testIdProps} from '@github-ui/test-id-props'
import {clsx} from 'clsx'

import {meterParts, type StackSegmentState} from './stack-segments'
import styles from './StackProgressMeter.module.css'

export function StackProgressMeter({
  segments,
  className,
}: {
  segments: readonly StackSegmentState[]
  className?: string
}) {
  const {continuous, parts} = meterParts(segments)

  return (
    <div
      className={clsx(styles.Meter, continuous && styles.continuous, className)}
      aria-hidden="true"
      {...testIdProps('stack-progress-meter')}
    >
      {parts.map(({state, length}, index) => (
        <span key={index} className={clsx(styles.Segment, styles[state])} style={{flexGrow: length}} />
      ))}
    </div>
  )
}
